import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventData } from '../providers/event';

@Pipe({
    name: 'staffConfigModule'
})

export class StaffConfigModuleDataPipe implements PipeTransform {

    constructor(
        private eventData: EventData
    ) { }

    transform(entityId: string, clientId: string, eventId): Observable<any> {
        if (eventId) {
            return this.eventData.getEventStaffData(clientId, entityId, eventId);
        }
        else {
            return this.eventData.getClientStaff(clientId, entityId);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pipes/staff-config-module.ts